import { useEffect } from "react";

const SITE = "STARSOX";
const ORIGIN = typeof window !== "undefined" ? window.location.origin : "https://starsox.de";

function upsert(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, description, image = "/assets/og-image.jpg", path = "" }) {
  useEffect(() => {
    const full = title ? `${title} | ${SITE}` : "STARSOX | Premium Grip-Socken – Designed for Performance";
    document.title = full;
    const img = image.startsWith("http") ? image : ORIGIN + image;
    const url = ORIGIN + path;

    upsert("name", "description", description);
    upsert("property", "og:title", full);
    upsert("property", "og:description", description);
    upsert("property", "og:type", "website");
    upsert("property", "og:site_name", SITE);
    upsert("property", "og:image", img);
    upsert("property", "og:url", url);
    upsert("property", "og:locale", "de_DE");
    upsert("name", "twitter:card", "summary_large_image");
    upsert("name", "twitter:title", full);
    upsert("name", "twitter:description", description);
    upsert("name", "twitter:image", img);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
  }, [title, description, image, path]);

  return null;
}
